require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-6-reasons-why-you-should-be-a-code-fellow.json") })
        }
      }, "path---blog-6-reasons-why-you-should-be-a-code-fellow");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-6-reasons-why-you-should-be-a-code-fellow!./.cache/json/blog-6-reasons-why-you-should-be-a-code-fellow.json
// module id = 568
// module chunks = 231608221292675